import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getSelectedEvent } from '@b/checkout/selectors/event';

const Protect = asyncComponent({
    resolve: () => import('./Protect'),
});

class ProtectWrapper extends Component {
    getSeatLabel = (seatInfo) => {
      let startWithComma = false;
      let _seat_info = '';
      if (!seatInfo?.row && !seatInfo?.seat){
        return '';
      }

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!seatInfo?.section){
          _seat_info += 'Sec ' + seatInfo.section;
          startWithComma = true;
      }

      const placeType = seatInfo?.isTableSeat ? 'Table' : 'Row';
      _seat_info += `${startWithComma ? ', ' : ''}${placeType} ${seatInfo.row}`;

      if (seatInfo?.isTableSeat || seatInfo?.row) {
        startWithComma = true;
      }
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!seatInfo?.seats) {
          _seat_info += (startWithComma? ', ':'') + 'Seat(s) ' + seatInfo.seats;
      }

      return _seat_info;
    }

    getFields() {
        const tickets = this.props.tickets.concat(this.props.bundleTickets).map((ticket) => {
          const seatLabel = this.getSeatLabel(ticket.seat_info);

          const result = {
            [`ticket_${ticket.id}_eventId`]: this.props.selectedEvent?.event_id,
            [`ticket_${ticket.id}_eventName`]: this.props.selectedEvent?.name,
            [`ticket_${ticket.id}_eventCategory`]: this.props.selectedEvent?.category ?? '',
            [`ticket_${ticket.id}_eventCity`]: this.props.selectedVenue?.address?.city,
            [`ticket_${ticket.id}_eventCountry`]: this.props.selectedVenue?.address?.country,
            [`ticket_${ticket.id}_eventOrganiser`]: this.props.organizer,
            [`ticket_${ticket.id}_venueName`]: this.props.selectedVenue?.name,
            [`ticket_${ticket.id}_ticketPriceLevel`]: ticket.price_level_name,
          };

          if (seatLabel) {
            result[`ticket_${ticket.id}_seatInfo`] = seatLabel;
          }

          return result;
        });

        const products = this.props.productSales.map((product) => ({
          [`product_${product.id}_eventId`]: this.props.selectedEvent?.event_id,
          [`product_${product.id}_eventName`]: this.props.selectedEvent?.name,
          [`product_${product.id}_eventCategory`]: this.props.selectedEvent?.category ?? '',
          [`product_${product.id}_eventCity`]: this.props.selectedVenue?.address?.city,
          [`product_${product.id}_eventCountry`]: this.props.selectedVenue?.address?.country,
          [`product_${product.id}_eventOrganiser`]: this.props.organizer,
          [`product_${product.id}_venueName`]: this.props.selectedVenue?.name,
          [`product_${product.id}_productName`]: product.product_name,
        }));
      const combinedList = [...tickets, ...products];
      return Object.assign({},...combinedList);
    }

    render() {
        return(
            <Protect
                selected={this.props.selected}
                price={this.props.price}
                loading={this.props.loading}
                declined={this.props.declined}
                onInsuranceChange={this.props.onInsuranceChange}
                widget_api_key={this.props.widget_api_key}
                version={this.props.version}
                sandbox={this.props.sandbox}
                templateId={this.props.templateId}
                insuranceItems={this.props.insuranceItems}
                currency={this.props.currency}
                locale={this.props.locale}
                setInsuranceOption={this.props.setInsuranceOption}
                mainEvent={this.props.mainEvent}
                mainVenue={this.props.mainVenue}
                reservation={this.props.reservation}
                seller_id={this.props.seller_id}
                seller_organization={this.props.seller_organization}
                itemsAsFields={this.getFields()}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const selectedEvent = getSelectedEvent(state);

    return {
        version: state.version,
        selectedEvent: selectedEvent?.event,
        selectedVenue: selectedEvent?.venue,
        tickets: state.tickets.tickets,
        bundleTickets: state.tickets.bundleTickets,
        productSales: state.productSales.products,
        organizer: selectedEvent?.seller_organization
    };
};

export default connect(mapStateToProps)(ProtectWrapper);

ProtectWrapper.propTypes = {
    version: PropTypes.string
};
